import { colors } from '@chegg-ui/theme'
import { fanta, PrimaryButton, OutlineButton } from '@chegg/fanta'
import styled from 'styled-components'
import { adjust, smallLayout } from '@chegg-wt/core/theme/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Heading = styled.h1`
  ${AspiraStack};
  font-size: ${fanta.font.size.xxl};
  font-weight: ${fanta.font.weight.bold};
  color: ${colors.dark};
  line-height: 37px;
  margin-top: 0px;
  @media (max-width: ${({ theme }) => adjust(smallLayout(theme), -1)}) {
    text-align: center;
  }
`

export const ConfirmButton = styled(PrimaryButton).attrs({
  isHoverAnimated: true,
  size: 'medium',
})`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  width: 189px;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    color: #fff;
  }
  @media (max-width: ${({ theme }) => adjust(smallLayout(theme), -1)}) {
    width: 100%;
  }
`

export const CancelButton = styled(OutlineButton).attrs({
  isHoverAnimated: true,
  size: 'medium',
})`
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor01};
  width: 189px;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    color: #fff;
  }
  @media (max-width: ${({ theme }) => adjust(smallLayout(theme), -1)}) {
    width: 100%;
  }
`
